import { Sizes } from '@theme/globals/sizing';
import { TypographySettings } from '@theme/globals/typography';
import theme from '@theme/sbot.theme';
const colors = theme.global.colors;

export const fancyRuleContainer = {
  alignItems: 'center',
  display: 'flex',
  justifyContent: 'center',
  width: '100%',
};

export const fancyRuleBorder = {
  background: colors['gray-300' as keyof typeof colors],
  borderRadius: Sizes[100],
  display: 'block',
  height: Sizes['1.5'],
  width: '100%',
};

export const fancyRuleLabel = {
  color: colors['gray-300' as keyof typeof colors],
  display: 'block',
  fontSize: TypographySettings.subhead.size,
  fontWeight: TypographySettings.subhead.weight,
  padding: `0 ${Sizes[16]}`,
};
